import React from 'react';
import styles from './popup.module.css';

const Popup = ({ extClass = '', closebtn, title, headMoreTxt, bodyMoreTxt, footMoreTxt }) => {
  return (
    <div className={`modal ${styles.popupsec} ${extClass}`}>
      <div className={styles.popupBlock}>
        <div className={styles.popupInnr}>
          {closebtn}
          <div className={styles.popupHead}>
            <h3 className={styles.popupTitle}>{title}</h3>
            {headMoreTxt}
          </div>
          <div className={styles.popupBody}>
            {bodyMoreTxt}
          </div>
          <div className={styles.popupFoot}>
            {footMoreTxt}
          </div>
        </div>
      </div>
      <div className={styles.popupOvly}></div>
    </div>
  );
};

export default Popup;